<template>
  <form-layout :label="label">
    <read-only-input :value="postalCodeValue" />
  </form-layout>
</template>

<script>
import FormLayout from '@/views/templates/FormLayout'
import ReadOnlyInput from "@/views/atoms/inputs/ReadOnlyInput";

export default {
  name: "PostalCodeBrowseItem",
  components: {
    FormLayout,
    ReadOnlyInput,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: '郵便番号'
    },
    value: {
      type: [String, null],
      required: true,
    }
  },
  computed: {
    postalCodeValue() {
      if (this.value && this.value.length === 7) {
        return this.value.substring(0, 3) + '-' + this.value.substring(3, 7);
      }
      return this.value;
    }
  }
}
</script>
